import { Metrics } from '../metrics';
import { propertyMetadataPersistedPromise } from 'fdsr-migration-layer';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
export const makePropertyMetadataClient = ({
  httpClient,
  persistedPromise = propertyMetadataPersistedPromise
}) => {
  const client = {
    /**
     * Prints debug info to the console.
     */
    debug: () => {
      persistedPromise.debug();
    },
    /**
     * Clears internal cache state.
     *
     * @returns A promise which resolves when state is clear.
     */
    clearCache: async () => {
      await Promise.all([persistedPromise.clearCache()]);
    },
    /**
     * Gets all property metadata entries for the specified app setting under the specified framework type.
     *
     * @param options.appSettingName The app setting to fetch entries for.
     * @param options.frameworkTypeIdentifier The framework type to fetch entries for under the app setting.
     * @param options.__isComposed For internal metrics tracking purposes only. Set to true when called within another client method.
     * @returns A promise which resolves to the property metadata entries, or null if the data could not be found.
     */
    get: ({
      frameworkTypeIdentifier,
      appSettingName,
      __isComposed = false
    }) => {
      if (!__isComposed) {
        Metrics.counter('propertyMetadata.get').increment();
      }
      return persistedPromise.makeFetchWithOpts({
        allowEagerCacheReturn: isEarlyCacheReturnEnabled()
      })({
        frameworkTypeIdentifier,
        appSettingName,
        httpClient
      });
    }
  };
  return Promise.resolve(client);
};